import React from 'react';

import './index.scss';

const SuccessText = ({ label }) => {

  return (
    <span className="SuccessText">{label}</span>
  );
};

export default SuccessText;